import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { get, post } from "../../actions/general";
import { editUser } from "../../store/user/actions";
import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

const mapStateToProps = ({ user }) => ({ user });
const mapDispatchToProps = {
    get,
    post,
    editUser,
};

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(loadingComponent))),
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({ title: allMessage["menu.moderation"], allMessage, lang });
    },
};
